import React from 'react'

// Minimal layout for public pages that manage their own styling
const Public = ({ children }) => <>{children}</>

export default Public
